//获取项目信息
import { getProjectListAPI } from '@/apis/project'
import { useState, useEffect } from 'react'

function useProjectList() {
    const [projectList, setProjectList] = useState([])
    useEffect(() => {
        const getCompanyList = async () => {
            const res = await getProjectListAPI()
            setProjectList(res.data)
        }
        getCompanyList()
    }, [])
    return {
        projectList
    }
}

export { useProjectList } 